import OneNetworkConfig from '@/onenetwork/core/onenetwork.config.ts'
import PrivateRouter from '@/onenetwork/layouts/PrivateRouter.vue'
import Attendance from '@/modules/backoffice/views/Attendance.vue'
const baseRoute = OneNetworkConfig.baseRoutePath
const backofficeRouter = [
  {
    path: `${baseRoute}/backoffice/attendance`,
    name: 'backoffice-attendance',
    meta: {
      component: Attendance
    },
    component: PrivateRouter,
  },
]
console.log(15, backofficeRouter)
export default backofficeRouter
